import AntIcon from "@/components/icons/AntIcon";
import { App as AntApp, Badge, Dropdown } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNotificationBadge } from "../../../common/api/queries";
import { useIsAuthenticated, useSelectedAccount } from "../../../modules/auth/hooks";
import { useNotifiedNotificationsActions } from "../../../modules/notifications/store";
import { NotificationDropdown } from "./NotificationDropdown";

export const NotificationView = () => {
  const { t } = useTranslation();
  const { notification: antNotification } = AntApp.useApp();

  const isUserAuthenticated = useIsAuthenticated();
  const { accountId } = useSelectedAccount();
  const notifiedNotificationsActions = useNotifiedNotificationsActions();

  const [open, setOpen] = useState(false);

  const { data } = useNotificationBadge(isUserAuthenticated);

  useEffect(() => {
    if (!data || !accountId) {
      return;
    }

    notifiedNotificationsActions.notificationsReceived(accountId, data.pageData).forEach((notification) => {
      antNotification.open({
        title: t("helpers.newNotification"),
        description: notification.data.content,
        icon: <AntIcon type="bell" color="blue" className="ringing-animation" />,
        duration: 10,
      });
    });
  }, [data?.pageData, accountId]);

  return (
    <Dropdown
      placement="bottomRight"
      styles={{ root: { width: 400 } }}
      destroyOnHidden
      popupRender={() => <NotificationDropdown open={open} onDropdownClose={() => setOpen(false)} />}
      open={open}
      onOpenChange={setOpen}
      trigger={["click"]}
    >
      <span style={{ display: "inline-block", cursor: "pointer", transition: "all 0.3s", padding: "0 12px" }}>
        <Badge count={data?.totalUnseenCount} style={{ fontSize: 14 }}>
          <AntIcon type="bell" style={{ fontSize: 18, verticalAlign: "middle" }} />
        </Badge>
      </span>
    </Dropdown>
  );
};
